<form [formGroup]="zimplerRegistrationForm">
    <div class="pnpSwFlow">
        <p class="pnpSwFlow-disc">{{'pnpNewflow.filltheInformation' | translate}}</p>

        <!-- Error Msg on Reset link -->
        <div class="pnpSwFlow__error" *ngIf="showResetPassword">
            <p>{{'pnpNewflow.errorMsg1' | translate}} <a (click)="resetPassword()">{{'pnpNewflow.errorMsg2' | translate}}</a>.</p>
        </div>
        
        <!-- email -->
        <div class="form-group" [ngClass]="getFormFiledClass('emailId',zimplerRegistrationForm)">
            <div class="controls">
                <input type="email" autocomplete="email-field" autocapitalize="off" formControlName="emailId"
                    name="emailId" class="floatLabel form-control" (focus)="onFocusForElement('emailId')"
                    (focusout)="onFocusOutForElement()" id="email" maxlength="64" />
                <label for="emailId">{{ 'registrationStepOne.emailAddress' | translate }}</label>
            </div>
            <div class="arrow_box "
            *ngIf="shouldShowErrors('emailId',zimplerRegistrationForm) && (zimplerRegistrationForm.controls['emailId'].value || iRegisterButtonClicked)">
            {{getErrorMessage('emailId',zimplerRegistrationForm)}} </div>
        </div>
        <div class="clearfix"></div>
        <!-- password -->
        <div class="form-group" [ngClass]="getFormFiledClass('password',zimplerRegistrationForm)">
            <div class="controls passwrd">
              <input autocomplete="password-field" [type]="viewPassword ? 'text' : 'password'" formControlName="password"
                name="password" id="password" class="floatLabel form-control pwdFloatLabel" (input)="trimPassword()"
                (focus)="onFocusForElement('pwd')" (focusout)="onFocusOutForElement()" />
              <label for="password">{{ 'registrationStepOne.password' | translate }}</label>
            </div>
            <span class="pwd-show" [ngClass]="viewPassword ? 'eyeshow' : ''" (click)="viewPassword = !viewPassword"><i
                class="icon-icon-eye"></i></span>
            <div 
              *ngIf="shouldShowPwdError('password',zimplerRegistrationForm) && (zimplerRegistrationForm.controls['password'].value|| iRegisterButtonClicked)"
              >
              <div class="arrow_box" *ngIf="focusPassword === true">
                {{'phnumbertext.title' | translate}}
              </div>
              <div class="arrow_box" *ngIf="focusPassword !== true">
                {{getErrorMessage('password',zimplerRegistrationForm)}}
              </div>
            </div>
            <!-- <div class="arrow_box_small passwrd_tooltip" *ngIf="shouldShowErrors('password',zimplerRegistrationForm)">{{getErrorMessage('password',zimplerRegistrationForm)}}</div> -->
          </div>
        <div class="clearfix"></div>
        <!-- phno -->
        <div class="form-group" [ngClass]="getFormFiledClass('phoneNumber',zimplerRegistrationForm)">
            <div class="tel-number controls" id="phoneNumberFlag">
                <input class="coutry-code form-control floatLabel inputWithoutDecimal" type="tel"
                    formControlName="phoneNumber" name="phoneNumber" (focus)="onFocusForElement('phoneNumber')"
                    (focusout)="onFocusOutForElement()">
                <label for="phoneNumberFlag" class="phone">{{'updateprofileComp.updateprofile8' | translate}}</label>
            </div>
            <div class="arrow_box_small" *ngIf="shouldShowPwdError('phoneNumber',zimplerRegistrationForm) && (zimplerRegistrationForm.controls['phoneNumber'].value || iRegisterButtonClicked) ">
                {{getErrorMessage('phoneNumber',zimplerRegistrationForm)}}</div>
        </div>
        <div class="clearfix"></div>

        <div class="form-group form-group--checkbox"
            [ngClass]="getFormFiledClass('termsAndCondition',zimplerRegistrationForm)">
            <div class="checkbox ">
                <input type="checkbox" autocomplete="checkbox" formControlName="termsAndCondition"
                    name="termsAndCondition"
                    [ngClass]="{'has-error':shouldShowErrors('termsAndCondition',zimplerRegistrationForm)}"
                    id="termsAndCondition" (focus)="onFocusForElement('termsAndCondition')"
                    (focusout)="onFocusOutForElement()" />
                <label for="termsAndCondition">
                    <span>{{ 'pnpNewflow.byCreatingAnAccountiAgree' | translate }} <a
                            routerLink="/{{langCode}}/page/terms-and-conditions"
                            [target]="'_blank'">{{ 'pnpNewflow.TermsAndConditions' | translate }}</a>
                        {{ 'registrationStepOne.and' | translate }} <a
                            routerLink="/{{langCode}}/page/marketing-communication"
                            [target]="'_blank'">{{ 'pnpNewflow.MarketingAgreement' | translate }}</a>
                        {{ 'registrationStepOne.duchExtensionJson'  | translate }}</span>
                </label>
            </div>
        </div>

        <div class="clearfix"></div>
        <p class="pnpSwFlow--disc text-center">{{ 'pnpNewflow.weeklyMonthlyLimits'| translate }} <a href="javascript:void(0)"
                (click)="toggleZDChat()">{{ 'pnpNewflow.weeklyMonthlyLimits1'| translate }}</a></p>
        <div class="clearfix"></div>
        <!-- <div class="mt20 text-center" *ngIf="showResetPassword">
            <button class="pnpSwFlow--resetlink"  (click)="resetPassword()">{{'pnpNewflow.pnpflowErrorMsg' | translate}}</button>
        </div> -->

    </div>
    <div class="clearfix"></div>
    
</form>